











































import { Component, Provide, Mixins } from "vue-property-decorator";
import CreatePassword from "@/components/app/global/fields/createPasswordField.vue";
import { IState } from "@/store";
import { mapState } from "vuex";
import { IUser } from "@/models/users";
import { Methods } from "@/models/methods";
import HasValidation from "@/mixins/HasValidation";
import { ValidationObserver } from "vee-validate";
import Context from "@/mixins/context";

@Component({
  components: {
    "create-password": CreatePassword
  },
  computed: {
    ...mapState({
      user: (state: IState) => state.user
    })
  }
})
export default class ChangePasswordForm extends Mixins(HasValidation, Context) {
  public declare $refs: {
    createPassword: CreatePassword;
    observer: InstanceType<typeof ValidationObserver>;
  };

  @Provide() public isProcessing = false;
  public newPassword = "";
  public oldPassword = "";
  public user!: IUser;

  public get isSubmitDisabled() {
    return (
      this.isProcessing ||
      this.newPassword.length === 0 ||
      this.oldPassword.length === 0
    );
  }

  public get apiUrl() {
    if (this.isAdmin) return "api/admin/users/";
    return "api/clients/";
  }

  public async changePassword() {
    this.clearErrors();
    this.isProcessing = true;
    try {
      await this.$store.dispatch("api/call", {
        method: Methods.PUT,
        path: `${this.apiUrl}${this.user.id}${this.isAdmin ? "" : "/login"}`,
        requestConfig: {
          data: {
            password: this.newPassword,
            old_password: this.oldPassword
          }
        }
      });

      this.$buefy.toast.open({
        message: this.$t("_sentence.password_changed") as string
      });
      this.oldPassword = this.newPassword = "";
      this.$refs.createPassword.clearInputs();
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
    this.isProcessing = false;
  }
}
